<template>
  <Merchant :param="param" v-if="param.app=='MP'" />
  <Crypto :param="param" v-else-if="param.app=='CR'" />
  <Chargeback :param="param" v-else-if="param.app=='CS'" />
  <echeck :param="param" v-else-if="param.app=='EC'" />
</template>

<script>
import Merchant from "../pages/merchantapp";
import echeck from "../pages/e-checkapps";
import Crypto from "../pages/cryptoapp";
import Chargeback from "../pages/chargebackshieldapp";
export default {
  components: {
    Merchant,
    echeck,
    Crypto,
    Chargeback
  },
  data: () => {
    return {
      param: {
        key: null,
        app: null
      }
    };
  },
  mounted() {
    this.param = this.$route.params;
    this.$store.dispatch("change_appcode", this.param);
  }
};
</script>

<style>
</style>